import { useEffect, useMemo, useRef, useState } from 'react'
import {
	getSevenDayColumnWidth,
	getShiftScheduleGridWidth,
	SHIFT_COLUMN_WIDTH,
	shouldStretchShiftColumns,
} from './shiftScheduleLayout'

export const useShiftScheduleScrollLayout = (dateCount: number) => {
	const scrollContainerRef = useRef<HTMLDivElement>(null)
	const [containerWidth, setContainerWidth] = useState(0)

	useEffect(() => {
		const element = scrollContainerRef.current
		if (!element) return

		const updateWidth = () => {
			setContainerWidth(element.clientWidth)
		}

		updateWidth()

		const observer = new ResizeObserver(updateWidth)
		observer.observe(element)

		return () => observer.disconnect()
	}, [dateCount])

	const stretchColumns = shouldStretchShiftColumns(dateCount)

	const columnWidth = useMemo(() => {
		if (stretchColumns) return SHIFT_COLUMN_WIDTH
		return getSevenDayColumnWidth(containerWidth)
	}, [stretchColumns, containerWidth])

	const gridWidth = useMemo(
		() => getShiftScheduleGridWidth(dateCount, columnWidth),
		[dateCount, columnWidth],
	)

	return {
		scrollContainerRef,
		stretchColumns,
		columnWidth,
		gridWidth,
	}
}
